import { h, Component } from 'preact';
import { bindActionCreators } from 'redux';
import { connect } from 'preact-redux';

import * as prosActions from '../../../actions/pros';
import * as sectorsActions from '../../../actions/sectors';
import { updateUserSettings } from '../../../actions/user';

import Search from '../../search/input';
import RadioBtns from '../../radio-buttons/leftSideBar';


import style from './style.scss';

class SearchPros extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sectors: this.convertSectors(this.props.sectors.sectors),
    }
  }

  componentDidMount() {
    const { userData: { userAuth }, fetchSectors, sectors: { sectors } } = this.props;
    if (!sectors.length) {
      fetchSectors(userAuth);
    }
  }

  componentWillReceiveProps(nextPros) {
    const { sectors: { sectors: sectors }, filter } = this.props;
    const { sectors: { sectors: newSectors }, filter: newFilter, updateUserSettings, getPros } = nextPros;
    if (newFilter && filter !== newFilter) {
      getPros();
      const splitedFilter = newFilter.split('.');
      updateUserSettings({ interestSector: [splitedFilter[0]], interestCategory: splitedFilter[1] ? [splitedFilter[1]] : [] })
    }

    if (!sectors.length && newSectors.length) {
      this.setState({
        sectors: this.convertSectors(newSectors)
      })
    }
  }

  convertSectors = (sectors) => {
    const data = [...sectors];
    data.name = 'SECTORS';
    return data;
  };

  render({ changeSearchParams, getPros, filter = '', searchTerm }, { sectors }) {
    return (
      <div className={style.searchPros}>
        <div className={style.sideBar}>
          <RadioBtns
            data={sectors}
            onChange={(value) => changeSearchParams({
              type: 'filter',
              value,
            })}
            value={{ radio: filter }}
            locale={this.props.locale}
            valueField="tag"
          />
        </div>
        <div className={style.searchInput}>
          <Search
            value={searchTerm}
            onSearch={getPros}
            onChange={(value) => changeSearchParams({
              type: 'searchTerm',
              value,
            })}
            locale={this.props.locale}
          />
        </div>
      </div>
    )
  }
}


const mapStateToProps = (state) => ({
  filter: state.pros.filter,
  searchTerm: state.pros.searchTerm,
  sectors: state.sectors,
  userData: state.loggedInUser,
  locale: state.locale.locale
});


const mapDispatchToProps = dispatch => bindActionCreators({
  getPros: prosActions.getPros,
  changeSearchParams: prosActions.changeSearchParams,
  fetchSectors: sectorsActions.fetchSectors,
  updateUserSettings,
}, dispatch);


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchPros);


// WEBPACK FOOTER //
// ./components/global/header/searchPros.js